import React from 'react'

import appStoreBadge from '@assets/app-store-badge.svg'
import googlePlayBadge from '@assets/google-play-badge.svg'
import { ModalBox, useModalContext } from '@fourthwall/components'
import { MOBILE_APP_ANDROID_LINK, MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links'

import code from './assets/code.png'
import * as S from './styled'

export const GetFourthwallAppModal = () => {
  const modal = useModalContext()

  return (
    <ModalBox title="Get the Fourthwall app" size="small" onClose={modal.close}>
      <p>Scan with your phone to download:</p>
      <S.Container>
        <S.QRCode src={code} alt="Code" />

        <S.Links>
          <div>
            <a href={MOBILE_APP_IOS_LINK} target="_blank" rel="noreferrer">
              <img src={appStoreBadge} alt="App Store Badge" />
            </a>
          </div>
          <div>
            <a href={MOBILE_APP_ANDROID_LINK} target="_blank" rel="noreferrer">
              <img src={googlePlayBadge} alt="Google Play Badge" />
            </a>
          </div>
        </S.Links>
      </S.Container>
    </ModalBox>
  )
}
